// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wClQZ{align-items:center;display:flex;justify-content:center}.hEVke{align-items:center;display:inline-flex;gap:.6rem}.Uh6PG.ui.label{background-color:var(--sui-color-blue);color:var(--anchore-color-white)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `wClQZ`,
	"sectionTitle": `hEVke`,
	"count": `Uh6PG`
};
module.exports = ___CSS_LOADER_EXPORT___;
